import Box from "@mui/material/Box";
import "./Chat.css";

interface propsType {
  broad_status: string;
  user_id: string;
  hidden_menu: boolean;
  sendMessage: any;
  iconSize: string;
  openChatInput: any;
}

const LiveChatBtn = (props: propsType) => {
  const onhandleChat = () => {
    if (props.user_id === "tester@test.com") {
      window.alert("현재 ID는 테스트용 ID입니다. 채팅은 리바트APP 또는 관리자화면에서 입력하세요.");
      return;
    }
    props.openChatInput(true);
  };

  return (
    <>
      {props.broad_status === "VOD" ? (
        <></>
      ) : (
        <Box
          sx={
            props.hidden_menu
              ? {
                  flexGrow: 1,
                  display: "none",
                }
              : {
                  flexGrow: 1,
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  marginTop: "10px",
                }
          }
          onClick={onhandleChat}
        >
          <img className="chat-btn-icon white-shadow" src="/images/chat.png" alt="" />
          <div className="chat-btn-title white-shadow">채팅하기</div>
        </Box>
      )}
    </>
  );
};

export default LiveChatBtn;
